import { useState, useEffect } from "react";
import "@/App.css";
import PasswordGate from "@/components/PasswordGate";
import HeroSection from "@/components/HeroSection";
import PersonalDetails from "@/components/PersonalDetails";
import ProfessionalBackground from "@/components/ProfessionalBackground";
import FamilyBackground from "@/components/FamilyBackground";
import InterestsValues from "@/components/InterestsValues";
import ContactSection from "@/components/ContactSection";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const saved = sessionStorage.getItem("profile_auth");
    if (saved === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  const handleAuthenticated = () => {
    sessionStorage.setItem("profile_auth", "true");
    setIsAuthenticated(true);
  };

  if (!isAuthenticated) {
    return <PasswordGate onSuccess={handleAuthenticated} />;
  }

  return (
    <div className="min-h-screen" style={{ background: "#FDFBF7" }} data-testid="profile-page">
      <HeroSection />
      <PersonalDetails />
      <ProfessionalBackground />
      <FamilyBackground />
      <InterestsValues />
      <ContactSection />
    </div>
  );
}

export default App;
